import React, { lazy } from 'react';

import { AgentVersionPickerBoundary } from './AgentVersionPickerBoundary';

export type AgentVersionPickerProps = {
	agentAri: string;
	canManage: boolean;
};

const AgentVersionPickerLazy = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant/agent-version-picker" */ './AgentVersionPickerInternal'
	).then((m) => ({ default: m.AgentVersionPickerInternal })),
);

export const AgentVersionPicker = ({
	agentAri,
	canManage,
}: AgentVersionPickerProps): React.JSX.Element => (
	<AgentVersionPickerBoundary>
		<AgentVersionPickerLazy agentAri={agentAri} canManage={canManage} />
	</AgentVersionPickerBoundary>
);
